<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>価格評価判定<span></span></p>
    </div>
    <div class="card">
        <div class="card-inner" style="text-align: center;">

            <div class="question-wrap" >
                <h3 class="_list-coin">Standard<span class="_svg-coin"><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /><SvgCoinGray /><SvgCoinGray /></span></h3>
                <h3 class="_list-coin">Highclass<span class="_svg-coin"><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /><SvgCoinGray /></span></h3>
                <h3 class="_list-coin">Luxury<span class="_svg-coin"><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /><SvgCoinBlack /></span></h3>
            </div>

        </div>

        <div class="control-wrap">
            <button type="button" class="_left" id="swiper-back-button" v-on:click="swiperBack1()"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next" ><span>Next</span></button>
        </div>

    </div>
</div>
</template>

<style>
._list-coin {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    margin: 0 auto;
}
._svg-coin {
    display: flex;
}
._svg-coin svg {
    width: 20px;
}
</style>

<script>
    import SvgCoinGray from '@/components/EndUser/svg/SvgCoinGray'
    import SvgCoinBlack from '@/components/EndUser/svg/SvgCoinBlack'

    export default {
        components: {
            SvgCoinGray,
            SvgCoinBlack,
        },
        computed: {
            categoriyLv1List (){
                return this.$store.state.register.form.Lv1;
            }
        },
        mounted() {
            let back_button = document.getElementById('swiper-back-button');
            back_button.disabled = false;
        },
        methods: {
            changeLv1 (categoriyLv1) {
                this.$store.state.register.form.select_priceZone_categoriyLv1 = categoriyLv1;
                this.isDisabled = false;
            },
            swiperBack1() {
                this.$emit("swiperBackPriceZone");
            }
        }
    }
</script>